import { FronteggContext } from '@frontegg/rest-api';
import { axiosAiva } from 'src/lib/axios';
import {
  listAgentSkillsConfig,
  createAgentSkillConfig,
  updateAgentSkillConfig,
  deleteAgentSkillConfig,
} from '../store/lib/agentSkill.url';

export type AgentSkill = {
  agent_skill_id: string;
  agent_id: string;
  name: string;
  description: string | null;
  is_supported: boolean;
  created_at: string;
  updated_at: string;
};

export type CreateAgentSkillPayload = {
  agent_id: string;
  name: string;
  description?: string;
  is_supported: boolean;
};

export type UpdateAgentSkillPayload = {
  name: string;
  description: string | null;
  is_supported: boolean;
};

function superadminHeaders(orgUuid: string) {
  const token = FronteggContext.getAccessToken();
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
    'Impersonate-Org-UUID': `${orgUuid}`,
    'Headless-Mode': true,
  };
}

export async function fetchAgentSkills(
  orgUuid: string,
  agentId: string
): Promise<AgentSkill[]> {
  const { url, params } = listAgentSkillsConfig(agentId);
  const result = await axiosAiva.get<{ agent_skills: AgentSkill[] }>(url, {
    headers: superadminHeaders(orgUuid),
    params,
  });
  return result?.data?.agent_skills ?? [];
}

export async function createAgentSkill(
  orgUuid: string,
  body: CreateAgentSkillPayload
): Promise<AgentSkill | undefined> {
  const { url } = createAgentSkillConfig();
  const result = await axiosAiva.post<{ agent_skill: AgentSkill }>(url, body, {
    headers: superadminHeaders(orgUuid),
  });
  return result?.data?.agent_skill;
}

export async function updateAgentSkill(
  orgUuid: string,
  agentSkillId: string,
  body: UpdateAgentSkillPayload
): Promise<AgentSkill | undefined> {
  const { url } = updateAgentSkillConfig(agentSkillId);
  const result = await axiosAiva.put<{ agent_skill: AgentSkill }>(url, body, {
    headers: superadminHeaders(orgUuid),
  });
  return result?.data?.agent_skill;
}

export async function deleteAgentSkill(
  orgUuid: string,
  agentSkillId: string
): Promise<void> {
  const { url } = deleteAgentSkillConfig(agentSkillId);
  await axiosAiva.delete(url, {
    headers: superadminHeaders(orgUuid),
  });
}
